var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-page"
  }, [_vm.pageTitleBlock && _vm.isDisplayingDoctorInfo ? _c('h1', {
    staticClass: "page-heading"
  }, [_vm._v(" " + _vm._s(_vm.pageTitleBlock.title) + " ")]) : _vm._e(), _c('div', {
    staticClass: "info-display"
  }, [_vm.breadcrumbsDisplay && !_vm.isDisplayingDoctorInfo ? _c('div', {
    staticClass: "breadcrumbs"
  }, [_vm._v(_vm._s(_vm.breadcrumbsDisplay))]) : _vm._e(), !_vm.isDisplayingDoctorInfo ? _c('h2', {
    staticClass: "main-title"
  }, [_vm.pageTitleBlock ? [_vm._v(" " + _vm._s(_vm.pageTitleBlock.title) + " ")] : [_vm._v(" " + _vm._s(_vm.mainTitleDisplay) + " ")]], 2) : _vm._e(), !_vm.isDisplayingDoctorInfo && _vm.pageTitleTextContent ? _c('div', {
    staticClass: "main-title-text-card"
  }, [_c('p', {
    staticClass: "main-title-text"
  }, [_vm._v(_vm._s(_vm.pageTitleTextContent))])]) : _vm._e(), _c('div', {
    staticClass: "info-card-wrapper"
  }, [_vm._l(_vm.contentBlocks, function (block, index) {
    return [block.type === 'html' ? _c('div', {
      key: "html-".concat(index),
      staticClass: "info-card"
    }, [_c('InfoHtml', {
      attrs: {
        "title": block.title,
        "content": block.content,
        "alt": block.alt,
        "list-unstyled": block.listUnstyled
      }
    })], 1) : _c('div', {
      key: "card-".concat(index),
      staticClass: "info-card"
    }, [block.type === 'text' ? _c('InfoText', {
      attrs: {
        "title": block.title,
        "content": block.content
      }
    }) : block.type === 'text-emphasized' ? _c('InfoTextEmphasized', {
      attrs: {
        "title": block.title,
        "content": block.content
      }
    }) : block.type === 'price' ? _c('div', {
      staticClass: "price-block"
    }, [_c('h3', {
      staticClass: "price-title"
    }, [_vm._v(_vm._s(block.title || '費用'))]), block.price ? _c('p', {
      staticClass: "price-value"
    }, [_vm._v(_vm._s(block.price) + _vm._s(_vm.priceUnit))]) : _vm._e(), block.textContent ? _c('p', {
      staticClass: "price-text-content"
    }, [_vm._v(" " + _vm._s(block.textContent) + " ")]) : _vm._e()]) : _vm._e(), block.type === 'image' ? _c('InfoImage', {
      attrs: {
        "title": block.title,
        "src": block.src,
        "alt": block.alt
      }
    }) : block.type === 'accordion' ? _c('InfoAccordion', {
      attrs: {
        "title": block.title,
        "content": block.content
      }
    }) : _vm._e()], 1)];
  })], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }